import ascend from "ramda/src/ascend";
import sort from "ramda/src/sort";
import * as React from "react";
import { AppliedFilter } from "../applied_filter/applied_filter";
import { Filter } from "../applied_filter/filter";
import { removeValuesFromArray } from "../helpers/handle_remove_filter";
import { arrayProperty } from "../helpers/filter_url_serialization";

const filterKey = "brandId";
const serializedKey = "znacka";
const displayName = "Značka";

export const BrandFilter: Filter = {
  key: "brand",
  serialize: (appliedFilter) => {
    const brandFilter = appliedFilter[filterKey];
    return brandFilter !== undefined
      ? arrayProperty(serializedKey, brandFilter)
      : null;
  },
  deserialize: (urlSearchParams: URLSearchParams) => {
    const brandFilter = urlSearchParams.get(serializedKey);
    if (brandFilter !== null) {
      const brandIds = brandFilter
        .split(",")
        .map((id) => parseInt(id))
        .filter((id) => !Number.isNaN(id));

      return brandIds.length > 0 ? { brandId: brandIds } : undefined;
    }
  },
  AppliedControlComponent: ({ appliedFilter, filterOptions, onRemove }) => {
    const brandFilter = appliedFilter[filterKey];
    if (brandFilter === undefined || brandFilter.length === 0) {
      return null;
    }

    const sortedBrands = sort(
      ascend((brand) => brand.index),
      brandFilter
        .map((brandId) => filterOptions.brandsById[brandId])
        .filter(Boolean)
    );

    return (
      <AppliedFilter
        filterName={displayName}
        values={sortedBrands}
        onRemove={(brandId) =>
          onRemove({
            ...appliedFilter,
            brandId: removeValuesFromArray(
              appliedFilter.brandId,
              brandId as number
            ),
          })
        }
      />
    );
  },
};
